import { createSlice } from "@reduxjs/toolkit";

const titleBarModel = {
  title: "",
  data: [],
  filteredData: [],
  isBackButton: false,
  isSearchBar: true,
  backButtonLabel: "",
  searchValue: "",
  overrideSearchFn: false,
};

export const titleBarSlice = createSlice({
  name: "titleBar",
  initialState: titleBarModel,
  reducers: {
    setTitleBar: (state, action) => {
      state.title = action.payload.title;
      state.data = action.payload.data;
      state.filteredData = action.payload.filteredData;
      state.isBackButton = action.payload.isBackButton;
      state.isSearchBar = action.payload.isSearchBar;
      state.backButtonLabel = action.payload.backButtonLabel;
      state.searchValue = action.payload.searchValue;
      state.overrideSearchFn = action.payload.overrideSearchFn;
    },
    setFilteredData: (state, action) => {
      state.filteredData = action.payload.filteredData;
    },
    setSearchValue: (state, action) => {
      state.searchValue = action.payload.searchValue;
    },
  },
});

export const { setTitleBar, setFilteredData, setSearchValue } = titleBarSlice.actions;

export default titleBarSlice.reducer;
